<template>
  <div>Solicitando permissão</div>
</template>
<script>
export default {
  methods: {
    emuladores: function (usuid) {
      this.$router.push({ path: '/seguranca/emuladores/' + usuid + '/true' })
    }
  },
  mounted: function () {
    this.emuladores(this.dadosUserSession.usuID)
  }
}
</script>
